import { useContext, useState } from "react";
import logo from "../../assets/logo-bendi.png";
import { useNavigate, useLocation, NavLink } from "react-router-dom";
import { AuthorizationContext } from "../../AuthorizationProvider";
import "./NavBar.css";

const NavBar = ({ name }) => {
  const { userRole } = useContext(AuthorizationContext);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigate = useNavigate();
  let location = useLocation();

  const logout = () => {
    localStorage.removeItem("que-bendicion-user");
    navigate("");
  };

  const handleMobileNavClick = () => {
    setIsMobileMenuOpen(false);
  };

  const navigationItems = [
    {
      to: "/caja",
      icon: "fa-cash-register",
      text: "CAJA",
      requiredRole: null,
    },
    {
      to: "/platos",
      icon: "fa-utensils",
      text: "PLATOS",
      requiredRole: 1,
    },
    {
      to: "/inventario",
      icon: "fa-box",
      text: "INVENTARIO",
      requiredRole: 1,
    },
    {
      to: "/reporte",
      icon: "fa-chart-bar",
      text: "REPORTE",
      requiredRole: 1,
    },
    {
      to: "/egresos",
      icon: "fa-money-bill-transfer",
      text: "GASTOS",
      requiredRole: 1,
    },
    {
      to: "/cierre-caja",
      icon: "fa-cash-register",
      text: "CIERRE CAJA",
      requiredRole: null,
    },
  ];

  const renderNavigationItems = (isMobile = false) => {
    return navigationItems
      .filter((item) => item.requiredRole === null || userRole !== 0)
      .map((item, index) => (
        <li
          key={index}
          className={isMobile ? "mobile-menu-item" : "sidebar-nav-item"}
        >
          <NavLink
            className={isMobile ? "mobile-menu-link" : "sidebar-nav-link"}
            to={item.to}
            onClick={isMobile ? handleMobileNavClick : undefined}
          >
            <i
              className={`fa-solid ${item.icon} ${isMobile ? "mobile-menu-icon" : "sidebar-icon"}`}
            ></i>
            <span
              className={
                isMobile
                  ? "mobile-menu-text"
                  : `sidebar-text ${isExpanded ? "show" : "hide"}`
              }
            >
              {item.text}
            </span>
          </NavLink>
        </li>
      ));
  };

  const showNavBar = () => {
    if (location.pathname === "/") {
      return "";
    } else {
      return (
        <>
          {/* Mobile Header */}
          <header className="mobile-header">
            <button
              className="mobile-hamburger"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle mobile menu"
            >
              <i
                className={`fa-solid ${isMobileMenuOpen ? "fa-times" : "fa-bars"}`}
              ></i>
            </button>
            <div className="mobile-header-content">
              <img alt="logo" className="mobile-header-logo" src={logo} />
              <span className="mobile-header-name">{name}</span>
            </div>
          </header>

          {/* Desktop Sidebar */}
          <nav
            className={`sidebar-nav ${isExpanded ? "expanded" : "collapsed"} desktop-sidebar`}
            onMouseEnter={() => setIsExpanded(true)}
            onMouseLeave={() => setIsExpanded(false)}
          >
            <div className="sidebar-header">
              <div className="logo-container">
                <img alt="logo" className="sidebar-logo" src={logo} />
                <span
                  className={`sidebar-name ${isExpanded ? "show" : "hide"}`}
                >
                  {name}
                </span>
              </div>
            </div>

            <ul className="sidebar-nav-list">
              {renderNavigationItems(false)}

              <li className="sidebar-nav-item">
                <button
                  className="sidebar-nav-link logout-btn"
                  onClick={logout}
                >
                  <i className="fa-solid fa-right-from-bracket sidebar-icon"></i>
                  <span
                    className={`sidebar-text ${isExpanded ? "show" : "hide"}`}
                  >
                    SALIR
                  </span>
                </button>
              </li>
            </ul>
          </nav>

          {/* Mobile Full-Width Menu */}
          <nav
            className={`mobile-menu ${isMobileMenuOpen ? "open" : "closed"}`}
          >
            <ul className="mobile-menu-list">
              {renderNavigationItems(true)}

              <li className="mobile-menu-item">
                <button
                  className="mobile-menu-link mobile-logout-btn"
                  onClick={() => {
                    logout();
                    handleMobileNavClick();
                  }}
                >
                  <i className="fa-solid fa-right-from-bracket mobile-menu-icon"></i>
                  <span className="mobile-menu-text">SALIR</span>
                </button>
              </li>
            </ul>
          </nav>
        </>
      );
    }
  };

  return showNavBar();
};

export default NavBar;
